<div class="edp-onboarding gesture__zone" 
(swipeleft)="slideRight()"
(swiperight)="slideLeft()">
    <div class="edp-onboarding-box desktop">
        <div class="edp-onboarding-close" (click)="close()">
            <i class="icon-edponline-Bop-071"  aria-hidden="true"></i>
        </div>
        <div *ngIf="currentPosition > 0" class="edp-onboarding-arrow left" (click)="slideLeft()">
            <i class="icon-edponline-Bop-078"  aria-hidden="true"></i>
        </div>
        <div *ngIf="currentPosition < itemList.length - 1" class="edp-onboarding-arrow right" (click)="slideRight()">
            <i class="icon-edponline-Bop-078"  aria-hidden="true"></i>
        </div>

        <div *ngFor="let slide of itemList" class="edp-onboarding-item" [ngStyle]="{ transform: 'translateX(' + translateValue + '%)' }">
            <div class="d-flex flex-column justify-content-center align-items-center edp-onboarding-item-wrapper">
                <div *ngIf="slide.image" class="edp-onboarding-item-image">
                    <img [src]="slide.image" alt="{{ slide.title }}" />
                </div>

                <div *ngIf="slide.animation" class="edp-onboarding-item-animation">
                    <ng-lottie [options]="options"></ng-lottie>
                </div>

                <div *ngIf="slide.icon">
                    <i class="edp-onboarding-item-icon {{ slide.icon }}"  aria-hidden="true"></i>
                </div>
                <div *ngIf="slide.title" class="edp-onboarding-item-title">{{ slide.title | translate }}</div>
                <div *ngIf="slide.description" class="edp-onboarding-item-description">{{ slide.description | translate }}</div>
                <div *ngIf="slide.button" class="edp-onboarding-item-button">
                    <button type="button" class="btn btn-primary" (click)="slide.button.action()">
                        {{ slide.button.label | translate }}
                    </button>
                </div>
            </div>
        </div>

        <div class="edp-onboarding-progress">
            <div
                *ngFor="let slide of itemList; let i = index"
                class="edp-onboarding-progress-step"
                [ngClass]="{ active: currentPosition === i }"
                (click)="goToSlide(i)"
            ></div>
        </div>
    </div>
    <div class="edp-onboarding-box mobile">
        <div class="edp-onboarding-close" (click)="close()">
            <i class="icon-edponline-Bop-071"  aria-hidden="true"></i>
        </div>
        <div *ngIf="currentPosition > 0" class="edp-onboarding-arrow left" (click)="slideLeft()">
            <i class="icon-edponline-Bop-078"  aria-hidden="true"></i>
        </div>
        <div *ngIf="currentPosition < itemListMobile.length - 1" class="edp-onboarding-arrow right" (click)="slideRight()">
            <i class="icon-edponline-Bop-078"  aria-hidden="true"></i>
        </div>

        <div
            *ngFor="let slide of itemListMobile"
            class="edp-onboarding-item"
            [ngStyle]="{ transform: 'translateX(' + translateValue + '%)' }"
        >
            <div class="d-flex flex-column justify-content-center align-items-center edp-onboarding-item-wrapper">
                <div *ngIf="slide.image" class="edp-onboarding-item-image">
                    <img [src]="slide.image" alt="{{ slide.title }}" />
                </div>

                <div *ngIf="slide.animation" class="edp-onboarding-item-animation">
                    <ng-lottie [options]="optionsMobile"></ng-lottie>
                </div>

                <div *ngIf="slide.icon">
                    <i class="edp-onboarding-item-icon {{ slide.icon }}"  aria-hidden="true"></i>
                </div>
                <div *ngIf="slide.title" class="edp-onboarding-item-title">{{ slide.title | translate }}</div>
                <div *ngIf="slide.description" class="edp-onboarding-item-description">{{ slide.description | translate }}</div>
                <div *ngIf="slide.button" class="edp-onboarding-item-button">
                    <button type="button" class="btn btn-primary" (click)="slide.button.action()">
                        {{ slide.button.label | translate }}
                    </button>
                </div>
            </div>
        </div>

        <div class="edp-onboarding-progress">
            <div
                *ngFor="let slide of itemListMobile; let i = index"
                class="edp-onboarding-progress-step"
                [ngClass]="{ active: currentPosition === i }"
                (click)="goToSlide(i)"
            ></div>
        </div>
    </div>
</div>
